import { safeLoader } from "@/lib/safe-loader";
import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";
import { resolveSeo, siteContentQuery } from "@/lib/site-content";
import { staffPortraitsQuery } from "@/lib/staff-portraits";
import { staffProfilesQuery } from "@/lib/staff-profiles";

import { AboutSchoolPage } from "../components/site/AboutSchoolPage";

export const Route = createFileRoute("/om-skolan")({
  loader: async ({ context }) => {
    const [data] = await Promise.all([
      safeLoader("sv.about.content", () => context.queryClient.ensureQueryData(siteContentQuery), undefined),
      // Porträttdata förladdas så personalbilderna inte dyker upp sent.
      safeLoader("sv.about.portraits", () => context.queryClient.ensureQueryData(staffPortraitsQuery), { portraits: {} }),
      context.queryClient.ensureQueryData(staffProfilesQuery),
    ]);
    return { seo: resolveSeo(data?.content, "om-skolan", "sv") };
  },
  head: ({ loaderData }) => {
    const title = loaderData?.seo.title ?? "";
    const description = loaderData?.seo.description ?? "";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
        { property: "og:url", content: absoluteUrl("/om-skolan") },
        { property: "og:locale", content: "sv_SE" },
        ...ogImage(),
      ],
      links: seoLinks("/om-skolan"),
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "EducationalOrganization",
            name: "Swedish International School",
            url: absoluteUrl("/om-skolan"),
            foundingDate: "2023",
            founders: [
              { "@type": "Person", name: "Anders Widén" },
            ],
            address: {
              "@type": "PostalAddress",
              addressLocality: "Estepona",
              addressRegion: "Málaga",
              addressCountry: "ES",
            },
          }),
        },
      ],
    };
  },
  component: AboutSchoolPage,
});
